module.exports = __webpack_public_path__ + "static/media/blog-de-noticias.30b054e3.png";